<template>
  <div v-if="rid && activityId" class="details-page">
    <div @click="back" class="back">返回</div>
    <div class="detail-img">
      <div :style="{backgroundImage: `url(${detail.detailImage})`}" class="gauss-wrapper" />
      <img :src="detail.detailImage" />
    </div>
    <div class="swiper-wrapper-bottom"></div>
    <div class="details-content">
      <div class="title">
        {{ detail.title }}
      </div>
      <div class="cities">
        <i class="location" />
        <div>
          <span v-for="(city, index) in detail.cities" :key="index" class="city">
            {{ city }}
          </span>
        </div>
      </div>
      <div v-if="content.text" class="detail-content">
        <div class="sub-title">
          {{ content.text }}
        </div>
        <div class="sub-content" v-html="content.content && content.content.replaceAll('\n', '<br>')" />
      </div>
      <div v-if="feature.text" class="detail-content">
        <div class="sub-title">
          {{ feature.text }}
        </div>
        <div class="sub-content" v-html="feature.content && feature.content.replaceAll('\n', '<br>')"/>
      </div>
      <div v-if="duration.content" class="detail-content duration">
        <div class="sub-title duration-title">
          {{ duration.text }}
        </div>
        <div class="sub-content duration-content" v-html="duration.content && duration.content.replaceAll('\n', '<br>')" />
      </div>
    </div>
  </div>

</template>

<script>
import { getRecommendRouteDetail, view } from "../../server/recommend-route"
import { mapGetters } from "vuex"
import qs from "qs"

export default {
  name: "RecommendRouteDetail",
  data() {
    return {
      detail: {}
    }
  },
  computed: {
    ...mapGetters("activityInfo", ["activityId"]),
    ...mapGetters("userInfo", ["userInfo"]),
    rid() {
      return this.$route.query.rid
    },
    content() {
      return this.detail?.content || {}
    },
    feature() {
      return this.detail?.feature || {}
    },
    duration() {
      return this.detail?.duration || {}
    }
  },
  created() {
    this.getRecommendRouteDetail()
    this.view()
  },
  methods: {
    getRecommendRouteDetail() {
      getRecommendRouteDetail({
        params: { id: this.rid },
        showLoading: true,
        showToast: true
      }).then((data) => {
        this.detail = data
      })
    },
    view() {
      view({ params: qs.stringify({ recommendRouteId: this.rid }), headers: { AUTHORIZATION: this.userInfo.userUuid } })
    },
    back() {
      const query = { id: this.activityId }
      const shopId = this.$route.query?.shopId
      if (shopId) {
        query.shopId = shopId
      }
      this.$router.replace({ path: "/recommendRoute", query })
    }
  }
}
</script>

<style lang="scss" scoped>
.details-page {
  width: 100%;
  height: 100vh;
  background: #fff;

  .back {
    width: 1rem;
    height: 0.64rem;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 0 38px 38px 0;
    position: fixed;
    left: 0;
    top: 0.3rem;
    z-index: 9999;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    line-height: 0.66rem;
    text-align: center;
    color: #ffffff;
    letter-spacing: 0;
    user-select: none;
  }

  .detail-img {
    position: relative;
    width: 100%;
    height: 3.8rem;
    overflow: hidden;

    .gauss-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 110%;
      height: 110%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      filter: blur(0.7rem);
      overflow: hidden;
    }

    & > img {
      position: relative;
      z-index: 3;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .swiper-wrapper-bottom {
    width: 100%;
    height: 0.2rem;
    border-radius: 0.2rem 0.2rem 0 0;
    background: #fff;
    position: absolute;
    top: 3.62rem;
    z-index: 10;
  }

  .details-content {
    position: relative;
    z-index: 2;
    background: #ffffff;
    padding: 0.3rem;

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 0.4rem;
      color: #333333;
      letter-spacing: 0;
      line-height: 0.46rem;
      font-weight: 600;
    }

    .cities {
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      display: flex;
      margin-top: 0.2rem;
      flex-wrap: wrap;

      & > div {
        flex: 1;
      }

      .location {
        display: inline-block;
        width: 0.18rem;
        height: 0.4rem;
        background: url("../../assets/images/icon_location.png") no-repeat center;
        background-size: contain;
        margin-right: 0.2rem;
      }

      .city {
        display: inline-block;
        margin-right: 0.12rem;
        margin-bottom: 0.05rem;
        line-height: 0.4rem;
      }
    }

    .detail-content {
      margin-top: 0.3rem;

      & + .detail-content {
        margin-top: 0.6rem;
      }

      .sub-title {
        position: relative;
        z-index: 1;
        font-family: PingFangSC-Semibold;
        font-size: 0.32rem;
        color: #333333;
        letter-spacing: 0;
        font-weight: 600;

        &::before {
          display: inline-block;
          content: '';
          width: 1.19rem;
          height: 0.09rem;
          position: absolute;
          left: 0;
          bottom: 0.09rem;
          z-index: -1;
          background: url('../../assets/images/tag_title_red.png') no-repeat;
          background-size: cover;
        }
      }

      .sub-content {
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        color: #666660;
        letter-spacing: 0;
        line-height: 0.4rem;
        font-weight: 400;
        margin-top: 0.2rem;
      }
    }

    .duration {
      display: flex;
      width: 100%;

      .duration-title {
        max-width: 50%;
        flex-shrink: 0;
        height: fit-content;
        word-break: break-all;
        line-height: 0.4rem;
      }

      .duration-content {
        margin-top: 0;
        margin-left: 0.2rem;
        word-break: break-all;
        line-height: 0.4rem;
      }
    }
  }
}
</style>

